var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStylishCondo = function SvgStylishCondo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4V20H16V4H7ZM6 2C5.44772 2 5 2.44772 5 3V22H18V3C18 2.44772 17.5523 2 17 2H6Z",
    fill: "#222F7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5H10V9H8V5Z",
    fill: "#222F7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H13V9H11V5Z",
    fill: "#222F7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H13V20H10V17Z",
    fill: "#222F7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H10V14H8V10Z",
    fill: "#222F7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H13V14H11V10Z",
    fill: "#222F7D"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStylishCondo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stylish-condo.c378bc62.svg";
export { ForwardRef as ReactComponent };